// extracted by mini-css-extract-plugin
export default {"root":"src_root__+meUV"};